import { InferType, object, string } from 'yup';

export const emailListSubscriptionSchema = object({
  email: string().trim().required().email('emailList.subscription.schema.error'),
}).defined();

export type EmailListSubscriptionSchema = InferType<typeof emailListSubscriptionSchema>;
